import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { toggleExpandableColumn } from '../redux/Slices/expandableColumnSlice';
import useDebouncedClick from './useDebouncedClick';

const useHandleExpandableColumnClick = () => {
    const dispatch = useDispatch();
    const expandableColumnState = useSelector((state) => state.expandableColumn);

    // Core handler function
    const handleExpandableColumnClickCore = useCallback((contentId, props = {}) => {
        // Allow immediate switching between different content types
        // but prevent rapid clicking on the same content
        const isSameContent = expandableColumnState.isVisible &&
                             expandableColumnState.contentId === contentId;

        // If it's the same content and already visible, allow toggle
        // If it's different content, allow immediate switch
        if (!isSameContent || !expandableColumnState.isVisible) {
            dispatch(toggleExpandableColumn({
                contentId,
                props,
            }));
        } else {
            // For same content toggle, use normal toggle behavior
            dispatch(toggleExpandableColumn({
                contentId,
                props,
            }));
        }
    }, [dispatch, expandableColumnState.isVisible, expandableColumnState.contentId]);

    // Apply debouncing to prevent spam clicking
    const handleExpandableColumnClick = useDebouncedClick(
        handleExpandableColumnClickCore,
        300, // 300ms debounce
        { allowSameTarget: false } // Prevent rapid clicks on same target
    );

    return { expandableColumnState, handleExpandableColumnClick };
};

export default useHandleExpandableColumnClick;
